import React, { Component } from "react"
import InputField from './fields/InputField';
// import SelectControl from './SelectControl';
import { validateFiscalCode } from '../../../utils/functions'
import SelectField from "./fields/SelectField"
import CheckboxField from "./fields/CheckboxField"
import SubmitButton from "./SubmitButton"

class FormComponent extends Component {
    state = {
        data: {},
        errors: {},
        schema: {}
    }

    handleChange = ({ currentTarget: item }) => {
        const data = { ...this.state.data }
        data[item.name] = item.value
        this.setState({ data });
    }

    handleCheckboxChange = ({ currentTarget: item }) => {
        const data = { ...this.state.data }
        data[item.name] = item.checked
        this.setState({ data });
    }


    handleSubmit = e => {
        e.preventDefault();
       this.doSubmit()
    }

    renderInput(name, label, type, placeholder) {
        const { data, errors, schema } = this.state

        let forceError = false
        if(name==='fiscal_code'){
            forceError = !validateFiscalCode(data[name])
        }

        let schemaItem = schema.filter(item => item.name === name)
        if(schemaItem.length > 0) { schemaItem = schemaItem[0] }

        return (
            <InputField
                type={type}
                name={name}
                required={schemaItem.required}
                value={data[name]}
                label={label}
                error={errors[name]}
                placeholder={placeholder}
                onChange={ this.handleChange }
            />
        )
    }

    renderCheckbox(name, label) {
        const { data, errors, schema } = this.state

        let schemaItem = schema.filter(item => item.name === name)
        if(schemaItem.length > 0) { schemaItem = schemaItem[0] }

        return (
            <CheckboxField
                name={name}
                value={data[name]}
                label={label}
                required={schemaItem.required}
                error={errors[name]}
                onChange={ this.handleCheckboxChange }
            />
        )
    }

    renderSelect(name, label, list, isDisabled) {
        const { data, errors, schema } = this.state
        let schemaItem = schema.filter(item => item.name === name)
        if(schemaItem.length > 0) { schemaItem = schemaItem[0] }

        return (
            <SelectField
                name={name}
                label={label}
                required={schemaItem.required}
                value={data[name]}
                error={errors[name]}
                list={list}
                isDisabled={isDisabled}
                onChange={ this.handleChange }
            />
        )
    }

    renderSubmit(label){
        return(
            <SubmitButton
                label={label}
                onClick={ () => this.submit() }
            />
        )
    }


}

export default FormComponent
